import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Button, Modal } from '@ibk/shared-ui';
import { TransactionFlow } from '../../enums';
import { pagamentosTranslations } from '../../translations';
import styles from './PixUnderReviewModal.module.css';
export function PixUnderReviewModalBase({ isOpen, flow, onClose, dataTestId = 'pix-under-review-modal', }) {
    const { t } = useTranslation();
    const isSent = flow === TransactionFlow.CASH_OUT;
    const titleKey = isSent ? 'pix-sent-under-review-modal-title' : 'pix-received-under-review-modal-title';
    const descriptionKey = isSent
        ? 'pix-sent-under-review-modal-description'
        : 'pix-received-under-review-modal-description';
    return (_jsx(Modal, { className: styles.pixUnderReviewModal, isOpen: isOpen, onClose: onClose, title: t(titleKey), closeOnBackdropClick: false, showCloseButton: true, "data-testid": dataTestId, children: _jsxs("div", { className: styles.content, children: [_jsx("p", { className: styles.description, "data-testid": `${dataTestId}-description`, children: t(descriptionKey) }), _jsx("div", { className: styles.actions, children: _jsx(Button, { onClick: onClose, className: styles.confirmButton, variant: 'secondary', size: 'medium', dataTestId: `${dataTestId}-confirm-button`, children: t('ok-i-understand') }) })] }) }));
}
export function PixUnderReviewModal(props) {
    return (_jsx(TranslationProvider, { translations: pagamentosTranslations, defaultLanguage: 'pt-BR', children: _jsx(PixUnderReviewModalBase, { ...props }) }));
}
export default PixUnderReviewModal;
